import { render, staticRenderFns } from "./CardStudentName.vue?vue&type=template&id=8d3fec16&scoped=true&"
import script from "./CardStudentName.vue?vue&type=script&lang=js&"
export * from "./CardStudentName.vue?vue&type=script&lang=js&"
import style0 from "./CardStudentName.vue?vue&type=style&index=0&id=8d3fec16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3fec16",
  null
  
)

export default component.exports